import { TranslationKey } from "types";
import { DeploymentVariant } from "../../GettingStartedWithUniFi.types";

export interface IHeroProps {
  config: IHeroSection;
  activeTabId?: DeploymentVariant;
}

export interface IHeroSection {
  id: number;
  label: TranslationKey;
  poster: string;
  src: string;
  loopSrc?: string;
  showGradient?: boolean;
  tooltips?: Array<ITourTooltip>;
}

export interface ITourTooltip {
  left?: string;
  right?: string;
  top?: string;
  id: number;
  bottom?: string;
  variant: AppVariant;
  description: TranslationKey;
  video: string;
}

export enum AppVariant {
  Network = "Network",
  Protect = "Protect",
  Access = "Access",
  Connect = "Connect",
}
